import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MainLayout } from '@components/layout';
import { Home, About, Services, Contact } from '@pages/index';

function App() {
  return (
    <BrowserRouter>
      <MainLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </MainLayout>
    </BrowserRouter>
  );
}

export default App;
